import { render, staticRenderFns } from "./EditFunctionSwitchDialog.vue?vue&type=template&id=51b8c7d5&"
import script from "./EditFunctionSwitchDialog.vue?vue&type=script&lang=js&"
export * from "./EditFunctionSwitchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports